<template>
<div class="md-layout">
    <div class="md-layout-item md-size-40 md-small-size-hide">
      <main-table :data="data" :lease="true" />
    </div>
    <div class="md-layout-item md-size-60 md-small-size-100">
        <h4 class="header-table">Sensibilidad Renta</h4>
        <md-table class="sensibility-table">
            <md-table-row>
              <md-table-cell class="first">&nbsp;</md-table-cell>
              <md-table-cell class="header">Variación</md-table-cell>
              <md-table-cell class="header">-25%</md-table-cell>
              <md-table-cell class="header">0%</md-table-cell>
              <md-table-cell class="header">+25</md-table-cell>
            </md-table-row>
            <md-table-row>
              <md-table-cell>Variación</md-table-cell>
              <md-table-cell >Rinde / Precio</md-table-cell>
              <md-table-cell>{{data['-25_precio_usd_t']}} USD/t</md-table-cell>
              <md-table-cell>{{data['0_precio_usd_tn']}} USD/t</md-table-cell>
              <md-table-cell>{{data['25_precio_usd_t']}} USD/t</md-table-cell>
            </md-table-row>
            <md-table-row>
              <md-table-cell class="header">-50%</md-table-cell>
              <md-table-cell class="header">{{data['-50_precio']}}</md-table-cell>
              <md-table-cell :style="'background-color:'+getStyleColor(73/100)">{{data['-25_-50']}}%</md-table-cell>
              <md-table-cell :style="'background-color:'+getStyleColor(70/100)">{{data['0_-50']}}%</md-table-cell>
              <md-table-cell :style="'background-color:'+getStyleColor(68/100)">{{data['25_-50']}}%</md-table-cell>
            </md-table-row>
            <md-table-row>
              <md-table-cell class="header">-25%</md-table-cell>
              <md-table-cell class="header">{{data['-25_precio']}}</md-table-cell>
              <md-table-cell :style="'background-color:'+getStyleColor(53/100)">{{data['-25_-25']}}%</md-table-cell>
              <md-table-cell :style="'background-color:'+getStyleColor(49/100)">{{data['0_-25']}}%</md-table-cell>
              <md-table-cell :style="'background-color:'+getStyleColor(34/100)">{{data['25_-25']}}%</md-table-cell>
            </md-table-row>
            <md-table-row >
              <md-table-cell>0%</md-table-cell>
              <md-table-cell class="header">{{data['0_precio']}}</md-table-cell>
              <md-table-cell :style="'background-color:'+getStyleColor(34/100)">{{data['-25_0']}}%</md-table-cell>
              <md-table-cell :style="'background-color:'+getStyleColor(28/100)">{{data['0_0']}}%</md-table-cell>
              <md-table-cell :style="'background-color:'+getStyleColor(23/100)">{{data['25_0']}}%</md-table-cell>
            </md-table-row>
            <md-table-row>
              <md-table-cell>+25%</md-table-cell>
              <md-table-cell class="header">{{data['25_precio']}}</md-table-cell>
              <md-table-cell :style="'background-color:'+getStyleColor(14/100)">{{data['-25_25']}}%</md-table-cell>
              <md-table-cell :style="'background-color:'+getStyleColor(7/100)">{{data['0_25']}}%</md-table-cell>
              <md-table-cell :style="'background-color:'+getStyleColor(1/100)">{{data['25_25']}}%</md-table-cell>
            </md-table-row>
            <md-table-row>
              <md-table-cell>+50%</md-table-cell>
              <md-table-cell class="header">{{data['50_precio']}}</md-table-cell>
              <md-table-cell :style="'background-color:'+getStyleColor(14/100)">{{data['-25_50']}}%</md-table-cell>
              <md-table-cell :style="'background-color:'+getStyleColor(7/100)">{{data['0_50']}}%</md-table-cell>
              <md-table-cell :style="'background-color:'+getStyleColor(1/100)">{{data['25_50']}}%</md-table-cell>
            </md-table-row>
          </md-table>
    </div>
</div>
</template>

<script>

import MainTable from '@/components/MainTable';

export default {
  name: 'sensibility',
  components: { MainTable },
  props: ['data'],
  methods: {
    getStyleColor(value){
      //value from 0 to 1
      var hue=((1-value)*120).toString(10);
      return ["hsl(",hue,",80%,55%)"].join("");
    }
  }
}
</script>
<style>
.sensibility-table .md-table-row td{
  border: 1px solid #ddd;
  text-align: center;
}
.sensibility-table .md-table-row .first{
  border-left: none;
  border-top:none;
}
.sensibility-table .md-table-row .header{
  height:18px;
  padding: 3px;
}
.sensibility-table .md-table-row .header{
  background-color: '#ddd'
}
.sensibility-table .md-table-cell {
  padding: 3px;
  height: 38px
}
.header-table{
  color: '#333';
  margin-top:0;
  margin-bottom:10px;
}

</style>
